export default __webpack_public_path__ + "static/media/posSystem.369412d6.svg";